// Builds
export const PUBLISH_LATEST = 'PUBLISH_LATEST';
export const COPY_VERSION = 'COPY_VERSION';

// Languages
export const ADD_LANGUAGE = 'ADD_LANGUAGE';
export const DELETE_LANGUAGE = 'DELETE_LANGUAGE';

// Locales
export const UPDATE_LOCALE = 'UPDATE_LOCALE';

// Namespaces
export const ADD_NAMESPACE = 'ADD_NAMESPACE';

// Projects
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const GET_PROJECTS = 'GET_PROJECTS';
export const GET_PROJECT = 'GET_PROJECT';

//Api Applications
export const CREATE_API_APPLICATION = 'CREATE_API_APPLICATION';
export const GET_API_APPLICATIONS = 'GET_API_APPLICATIONS';
export const UPDATE_API_APPLICATIONS = 'UPDATE_API_APPLICATIONS';
export const GET_API_APPLICATION = 'GET_API_APPLICATION';
export const REGENERATE_API_APPLICATION_TOKEN =
  'REGENERATE_API_APPLICATION_TOKEN';

// Translations
export const DELETE_TRANSLATION_KEY = 'DELETE_TRANSLATION_KEY';
export const GET_TRANSLATIONS = 'GET_TRANSLATIONS';
export const GET_TRANSLATIONS_BY_NAME = 'GET_TRANSLATIONS_BY_NAME';
export const UPSERT_PRIMARY_TRANSLATION = 'UPSERT_PRIMARY_TRANSLATION';
export const UPSERT_TRANSLATION = 'UPSERT_TRANSLATION';
export const UPSERT_TRANSLATIONS = 'UPSERT_TRANSLATIONS';

// Site Wide
export const NAVIGATION = 'NAVIGATION';

// Versions
export const GET_VERSIONS = 'GET_VERSIONS';
export const ADD_VERSION = 'ADD_VERSION';
export const DELETE_VERSION = 'DELETE_VERSION';
